// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__38huT","tab":"ProcedureTabs_tab__2doVi"};